








import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';

@Component
export default class SectionHeader extends Vue {
  @Prop() private title!: string;
  @Prop() private styles!: string | object;

  private get showArrow(): boolean {
    if (!this.styles) {
      return true;
    }
    if (typeof this.styles !== 'string') {
      return true;
    }
    return !this.styles.includes('tollbar_editable');
  }
}
